// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/src';
import { withRouter } from 'react-router';
import { History, Match } from 'react-router-dom';
import { Box } from 'grommet';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import MeasureRoutes from 'esm-web-pro/containers/map/measure/MeasureRoutes';
import RedButton from 'esm-web-pro/components/layout/RedButton';


const MEASURE_PANEL_ID = 'MEASURE_PANEL_ID';

type Props = {
    editor: BaseEditor,

    leaflet: LeafletContext,
    history: History,
    match: Match,
};

const MeasureRoutesContainer = (props: Props) => {
    const {
        editor, leaflet: { map }, history, match,
    } = props;

    const handleClose = () => {
        map.measuring = false;
        history.push(`${match.url.split('/measure')[0]}`);
    };

    React.useEffect(() => {
        map.measuring = true;

        return () => {
            map.measuring = false;
        };
    }, [map]);

    return (
        <SidePane
            id={MEASURE_PANEL_ID}
            openInitially
            title={(<FormattedMessage id="measure-routes-title" defaultMessage="Measure routes" />)}
        >
            <Box justify="between" height="100%">
                <Box>
                    <MeasureRoutes editor={editor} />
                </Box>
                <Box flex={{ shrink: 0 }} pad={{ horizontal: 'medium', vertical: 'small' }}>
                    <RedButton
                        label={(<FormattedMessage id="close-button" defaultMessage="Close" />)}
                        onClick={handleClose}
                        color="status-error"
                    />
                </Box>
            </Box>
        </SidePane>
    );
};

export default withRouter(withLeaflet(MeasureRoutesContainer));
